import React from 'react';

const WelcomeHeader = () => {
  return (
    <div className="text-center mb-8 md:mb-10 lg:mb-12 px-4">
      <div className="inline-flex items-center justify-center w-48 h-48 md:w-60 md:h-60 lg:w-72 lg:h-72 bg-primary/10 rounded-xl md:rounded-2xl mb-2 md:mb-3">
        <img
          src="/assets/images/MyBodyToday_logo_design2-removebg-preview1-1770673381636.png"
          alt="MyBodyToday Logo"
          className="w-36 h-36 md:w-48 md:h-48 lg:w-60 lg:h-60 object-contain"
        />
      </div>
      
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
        Select Your Profile
      </h1>
      
      <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
        Choose the profile that best describes you. This helps us tailor your symptom tracking experience to your specific needs.
      </p>
    </div>
  );
};

export default WelcomeHeader;